import React from 'react';
import {Provider} from "components/sec-question/SecQuestionContext";
import {SecQuestionList} from "components/sec-question/SecQuestionList";

export const SecQuestions = () => {

    return (
        <Provider>
            <SecQuestionList/>
        </Provider>
    );
}
